import { createContext } from "react";

const ResourcesUniversitySpacesContext = createContext({
    loadingRequestOfReservationAction: null,
    spaceList: {
        triggerFilling: () => {},
        fill: async () => {},
        clear: () => {},
        value: [],
        updateSpace: newSpace => {},
        removeSpace: spaceId => {},
        isEmpty: () => true,
        reservations: {
            update: (reservation, reservationType) => {},
            remove: (reservation, reservationType) => {}
        }
    },
    toastMessage: {
        hide: () => {}, show: message => {}
    }
});

export default ResourcesUniversitySpacesContext;